import { BaseService } from "services/_baseService";

class KnowledgeDocumentsService extends BaseService<any> {
  constructor() {
    super(`knowledge-documents`);
  }
}

export default new KnowledgeDocumentsService();
